import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import GridMotion from 'components/GridMotion';
import { BASE_LAYOUT_SPECS } from '../../constants';
import Widget from '../Widget';

import styles from './styles';

const useStyles = createUseStyles(styles, 'GridContainer');

const GridContainer = memo(
    ({ dashboardFilters, forceBIUtils, googleMapsApiKey, getSnapshot, initWidget, ...props }) => {
        const classes = useStyles();

        return (
            <div className={classes.root}>
                <GridMotion
                    dashboardFilters={dashboardFilters}
                    forceBIUtils={forceBIUtils}
                    googleMapsApiKey={googleMapsApiKey}
                    getSnapshot={getSnapshot}
                    baseLayoutSpecs={BASE_LAYOUT_SPECS}
                    widgetComp={Widget}
                    initWidget={initWidget}
                    isLazy={true}
                    {...props}
                />
            </div>
        );
    },
);

export default GridContainer;
